<template>
	<div class="landing-page">
		<div class="header-gradient-background">
			<div class="header">
				<img class="logo" src="@/assets/inbox_kitten.png" />
				<h1>
					Use for
					<a></a> Email Changing purposes only
				</h1>
				<h2>Enter the email provided to you here!</h2>
			</div>
			<div class="email-selection">
				<form v-on:submit.prevent="goToInbox">
					<div class="input-box">
						<input
							class="input-email"
							name="email"
							aria-label="email"
							type="text"
							v-model="randomName"
							id="email-input"
						/>
						<div class="input-suffix" id="div-domain" data-clipboard-target="#email-input">@{{domain}}</div>
					</div>
					<div class="submit-box">
						<input type="submit" class="submit" value="Get Mail!" />
					</div>
				</form>
			</div>
		</div>
		<div class="love-notes">
			<p>
				Served by
				<a href="https://csgoallrankstore.com">CSGOAllRankStore</a>
				<span style="color: #e25555;">&hearts;</span>
			</p>
			<p>
			Don't use these emails for personal use. It maybe discontinued anytime. This is solely meant for the purpose of getting steam codes to change email.
			</p>
		</div>
	</div>
</template>
<script>
import $ from 'jquery'
import config from '@/../config/apiconfig.js'
import 'normalize.css'
import ClipboardJS from 'clipboard'

export default {
	name: 'LandingPage',
	data () {
		return {
			randomName: ''
		}
	},
	mounted () {
		this.randomName = this.generateRandomName().toString()

		this.$clipboard = []

		let self = this

		this.$clipboard[0] = new ClipboardJS('#div-domain', {
			text: function (trigger) {
				if (self.randomName.includes('@' + config.domain)) {
					return self.randomName
				}
				return self.randomName + '@' + config.domain
			}
		})

		this.$clipboard[0].on('success', function (e) {
			$('#email-input').select()
			$('#div-domain').addClass('tooltipped tooltipped-s')
			$('#div-domain').attr('aria-label', 'Copied!')
			$('#div-domain').on('mouseleave', function () {
				$('#div-domain').removeClass('tooltipped tooltipped-s')
				$('#div-domain').removeAttr('aria-label')
			})
		})
	},
	beforeDestroy () {
		if (this.$clipboard !== null) {
			this.$clipboard.forEach(cb => {
				cb.destroy()
			})
		}
	},
	computed: {
		domain () {
			return config.domain
		}
	},
	methods: {
		generateRandomName () {
			var randomWords = require('random-words')
			return (
				randomWords({
					exactly: 1,
					wordsPerString: 2,
					separator: '-'
				}) +
				'-' +
				Math.floor(Math.random() * 90 + 10)
			)
		},
		goToInbox () {
			this.$router.push({
				name: 'Inbox',
				params: {
					email: this.randomName
				}
			})
		},
		goToKittenRouter () {
			location.href = '/'
		}
	}
}
</script>

<style lang="scss" rel="stylesheet/scss">
	@import url("https://use.fontawesome.com/releases/v5.3.1/css/all.css");
	@import "scss/landingpage.scss";
	@import "primer-tooltips/index.scss";

	.landing-navigation {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		float: right;
		width: 100vw;
		height: 1rem;
		text-align: left;

		.landing-nav-main-logo {
			width: 8rem;
			padding-top: 7rem;
			padding-right: 4rem;
			z-index: 2;
		}

		.landing-nav-header {
			padding-top: 6rem;
			padding-right: 3rem;
			cursor: pointer;
		}
	}

	@media only screen and (max-width: 470px) {
		.landing-navigation .landing-nav-main-logo {
			padding-right: 4rem;
			width: 5rem;
			z-index: 3;
		}
		.landing-nav-header {
			display: none;
		}
	}
	@media only screen and (max-width: 800px) {
		.landing-navigation {
			padding-top: 140px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/landingpage.vue